import type { ComponentType } from 'react';
import type { BuilderStep } from '../../../lib/types.js';
import { pickerVariables, type StepPath } from '../definitionEdit.js';
import type { StepArmProps } from '../StepArm.js';
import type { StepListContext } from '../stepTypes.js';
import { AgentStepEditor } from './AgentStepEditor.js';
import { ApprovalStepEditor } from './ApprovalStepEditor.js';
import { BranchStepEditor } from './BranchStepEditor.js';
import { FilterStepEditor } from './FilterStepEditor.js';
import { NotificationStepEditor } from './NotificationStepEditor.js';
import { ReportStepEditor } from './ReportStepEditor.js';
import { BotStepEditor } from './BotStepEditor.js';

export const StepEditor = ({
  step,
  path,
  ctx,
  Arm,
}: {
  step: BuilderStep;
  path: StepPath;
  ctx: StepListContext;
  Arm: ComponentType<StepArmProps>;
}) => {
  const vars = pickerVariables(ctx.definition, path, ctx.triggerFields, ctx.personas);
  const onChange = (next: BuilderStep) => ctx.onReplace(path, next);
  const props = { path, ctx, vars, onChange };
  const editor = () => {
    switch (step.type) {
      case 'filter':
        return <FilterStepEditor {...props} step={step} />;
      case 'branch':
        return <BranchStepEditor {...props} step={step} Arm={Arm} />;
      case 'notify':
        return <NotificationStepEditor {...props} step={step} />;
      case 'agent':
        return <AgentStepEditor {...props} step={step} />;
      case 'approval':
        return <ApprovalStepEditor {...props} step={step} Arm={Arm} />;
      case 'report':
        return <ReportStepEditor {...props} step={step} />;
      case 'bot':
        return <BotStepEditor {...props} step={step} />;
    }
  };
  return (
    <div className="grid min-w-0 gap-2 rounded-b-lg border border-t-0 border-outline-strong bg-surface-elevated p-3">
      {editor()}
    </div>
  );
};
